import {getOktaAuthInstance} from 'core/stores/auth';

export const oktaLogout = () => {
  getOktaAuthInstance()?.signOut();
};

export const refreshOktaToken = async () => {
  const authInstance = getOktaAuthInstance();

  if (!authInstance) {
    return;
  }

  try {
    const tokens = await authInstance.token.renewTokens();
    return tokens.idToken?.idToken;
  } catch {
    authInstance.signInWithRedirect({
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      originalUri: window.location.origin + window.location.pathname,
    });
    return null;
  }
};
